<template>
    <div class="modal fade" id="promptModal" tabindex="-1" role="dialog" aria-labelledby="promptModalTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="promptModalTitle">{{ promptTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{ promptMessage }}</p>
                </div>
                <div class="modal-footer">
                    <button v-if="buttons.includes('ok')" type="button" class="btn btn-primary" @click="buttonClicked('ok')">OK</button>
                    <button v-if="buttons.includes('yes')" type="button" class="btn btn-primary" @click="buttonClicked('yes')">Yes</button>
                    <button v-if="buttons.includes('no')" type="button" class="btn btn-secondary" @click="buttonClicked('no')">No</button>
                    <button v-if="buttons.includes('cancel')" type="button" class="btn btn-secondary" @click="buttonClicked('cancel')">Cancel</button>
                    <button v-if="buttons.includes('close')" type="button" class="btn btn-secondary" @click="buttonClicked('close')">Close</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>

import $ from '@/lib/JQuery.js'
import logger from '@/lib/logger.js'

export default {
    name: 'PromptDialog',
    data() {
        return {
            buttons: [],
            promptMessage: '',
            promptTitle: '',
            handler: null
        }
    },
    methods: {
        show(title, message, buttons, handler) {
            logger.log('PromptDialog::show()')
            this.promptMessage = message
            this.promptTitle = title
            this.buttons = buttons
            this.handler = handler

            $(this.$refs.modal).modal('show')
        },
        buttonClicked(btnID) {
            if (typeof this.handler == 'function') {
                this.handler(btnID)
            }

            $(this.$refs.modal).modal('hide')
        }
    }
}
</script>

<style>

</style>
